"use strict";
(() => {
  function init(scope) {
    scope.querySelectorAll('[data-product-root]').forEach(root => {
      if (root.dataset.saleReady) return;
      const badge=root.querySelector('[data-sale-badge]');
      const data=root.querySelector('[data-sale-prices]');
      const select=root.querySelector('[data-variant-select]');
      if (!badge || !data || !select) return;
      let prices;
      try { prices=JSON.parse(data.textContent); } catch { return; }
      root.dataset.saleReady='true';
      const update=() => {
        const variant=prices.find(item => String(item.id)===select.value);
        const percent=variant && variant.compare>variant.price && variant.compare>0 ? Math.round((variant.compare-variant.price)*100/variant.compare) : 0;
        badge.hidden=percent<=0;
        badge.textContent=`−${percent}%`;
        badge.setAttribute('aria-label',`${percent}% off the selected pillow's reference price`);
      };
      select.addEventListener('change',update);
      update();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
